import axios from "axios";
import Config from "../config";
import RefreshTokenHandler from "../refreshToken/refreshToken";

export const updateAlignerSchedulePictures = async (data) => {
  try {
    const token = sessionStorage.getItem("token");
    const url = `${Config.baseUrl}/aligner-schedule/${data.aligner_schedule_id}`;
    const formData = new FormData();
    let keys = Object.keys(data);
    for (let i = 0; i < keys.length; i++) {
      let temp = keys[i];

      if (
        typeof data[temp] == "object" &&
        temp !== "before_smily_picture" &&
        temp !== "before_teeth_picture" &&
        temp !== "before_buccal_left_picture" &&
        temp !== "before_buccal_right_picture" &&
        temp !== "before_occlusal_upper" &&
        temp !== "before_occlusal_lower" &&
        temp !== "after_smily_picture" &&
        temp !== "after_front_teeth_picture" &&
        temp !== "after_buccal_left_picture" &&
        temp !== "after_buccal_right_picture" &&
        temp !== "after_occlusal_upper" &&
        temp !== "after_occlusal_lower"
      ) {
        formData.append(temp, JSON.stringify(data[temp]));
      } else {
        formData.append(temp, data[temp]);
      }
    }

    const result = await axios.put(url, formData, {
      headers: {
        Authorization: token || "",
      },
    });
    return result;
  } catch (err) {
    if (err.response.data.status === 401 || err.response.status === 403) {
      let responseToHandle = err.response.data;
      let result = await RefreshTokenHandler.handleIt(responseToHandle);
      if (result.status) {
        return await updateAlignerSchedulePictures(data);
      } else {
        throw err;
      }
    } else {
      return err.response;
    }
  }
};

export const getAlignerScheduleByCaseId = async (email, case_id) => {
  try {
    const token = sessionStorage.getItem("token");
    const url = `${Config.baseUrl}/aligner-schedule/by-case-id?email=${email}&case_id=${case_id}`;
    const result = await axios.get(url, {
      headers: {
        Authorization: token || "",
      },
    });
    return result;
  } catch (err) {
    if (err.response.data.status === 401 || err.response.status === 403) {
      let responseToHandle = err.response.data;
      let result = await RefreshTokenHandler.handleIt(responseToHandle);
      if (result.status) {
        return await getAlignerScheduleByCaseId(email, case_id);
      } else {
        throw err;
      }
    } else {
      throw err;
    }
  }
};
